export const CORE_STATE_TOKEN = 'CORE';

export const CORE_API_PATHS = {
    configuration: 'client/configuration',
    configuration_include: '?include_fields=translations'
};
